export default __webpack_public_path__ + "static/media/linkedinLogo.692cae71.png";